import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up",
  style: {"width":"680px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "rk-modal-title" }
const _hoisted_5 = ["disabled", "placeholder"]
const _hoisted_6 = { class: "rk-row" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  value: null,
  disabled: ""
}
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "rk-owners" }
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 1,
  class: "rk-hint"
}
const _hoisted_16 = { class: "rk-owners" }
const _hoisted_17 = ["title", "onClick"]
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 1,
  class: "rk-hint"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "rk-seg" }
const _hoisted_23 = ["disabled", "onClick"]
const _hoisted_24 = { class: "rk-label" }
const _hoisted_25 = { class: "rk-hint" }
const _hoisted_26 = {
  key: 0,
  class: "crm-checklist-handle",
  title: "Drag to reorder",
  "aria-hidden": "true"
}
const _hoisted_27 = ["onUpdate:modelValue", "disabled", "aria-label", "onChange"]
const _hoisted_28 = ["onUpdate:modelValue", "disabled"]
const _hoisted_29 = ["onUpdate:modelValue", "disabled"]
const _hoisted_30 = { value: null }
const _hoisted_31 = ["value"]
const _hoisted_32 = ["onUpdate:modelValue", "disabled", "min", "max"]
const _hoisted_33 = { class: "rk-ms-wk" }
const _hoisted_34 = ["title", "onClick"]
const _hoisted_35 = ["href", "title"]
const _hoisted_36 = {
  key: 3,
  class: "rk-ms-ln"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "rk-ms-link"
}
const _hoisted_39 = ["href", "title"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onUpdate:modelValue", "disabled"]
const _hoisted_42 = ["href"]
const _hoisted_43 = {
  key: 2,
  class: "rk-hint"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  class: "rk-hint",
  style: {"margin":"0 0 6px"}
}
const _hoisted_46 = { class: "rk-actions" }
const _hoisted_47 = {
  key: 0,
  class: "rk-actions-side"
}
const _hoisted_48 = { class: "rk-actions-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_forge_rock_milestones = _resolveComponent("forge-rock-milestones")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.existing ? (_ctx.editable ? 'Update Rock' : 'Rock') : 'Add Rock') + " · " + _toDisplayString(_ctx.quarterLabel(_ctx.quarter)), 1),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "rk-label" }, "Rock", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Name) = $event)),
        disabled: !_ctx.editable,
        placeholder: 'What must be done by ' + _ctx.shortDate(_ctx.bounds.end) + '? Specific and measurable.',
        ref: "nameInput"
      }, null, 8, _hoisted_5), [
        [_vModelText, _ctx.form.Name]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "rk-label" }, "Owner", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.OwnerEmployeeID) = $event)),
            disabled: !_ctx.editable
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, "No owner", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.ID,
                value: e.ID
              }, _toDisplayString(e.Name), 9, _hoisted_8))
            }), 128))
          ], 8, _hoisted_7), [
            [_vModelSelect, _ctx.form.OwnerEmployeeID]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "rk-label" }, "Team", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Team) = $event)),
            disabled: !_ctx.editable
          }, [
            (!_ctx.form.Team)
              ? (_openBlock(), _createElementBlock("option", _hoisted_10, "Pick a team"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamOptions, (t) => {
              return (_openBlock(), _createElementBlock("option", {
                key: t,
                value: t
              }, _toDisplayString(_ctx.teamLabel(t)), 9, _hoisted_11))
            }), 128))
          ], 8, _hoisted_9), [
            [_vModelSelect, _ctx.form.Team]
          ])
        ])
      ]),
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "rk-label" }, "Additional Owners", -1)),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.AdditionalOwnerIDs, (id) => {
          return (_openBlock(), _createElementBlock("span", {
            key: id,
            class: "rk-owner-chip"
          }, [
            _createTextVNode(_toDisplayString(_ctx.employeeName(id)) + " ", 1),
            (_ctx.editable)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "rk-owner-x",
                  title: 'Remove ' + _ctx.employeeName(id),
                  onClick: ($event: any) => (_ctx.removeOwner(id))
                }, [
                  _createVNode(_component_svg_icon, { icon: "x" })
                ], 8, _hoisted_13))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.editable && _ctx.ownerChoices.length)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addOwnerID) = $event)),
              class: "rk-owner-add",
              "aria-label": "Add an owner",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addOwner()))
            }, [
              _cache[23] || (_cache[23] = _createElementVNode("option", { value: null }, "+ Add Owner", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownerChoices, (e) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: e.ID,
                  value: e.ID
                }, _toDisplayString(e.Name), 9, _hoisted_14))
              }), 128))
            ], 544)), [
              [_vModelSelect, _ctx.addOwnerID]
            ])
          : _createCommentVNode("", true),
        (!_ctx.editable && !_ctx.form.AdditionalOwnerIDs.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "None"))
          : _createCommentVNode("", true)
      ]),
      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "rk-label" }, "Additional Teams", -1)),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.AdditionalTeams, (t) => {
          return (_openBlock(), _createElementBlock("span", {
            key: t,
            class: "rk-owner-chip"
          }, [
            _createTextVNode(_toDisplayString(_ctx.teamLabel(t)) + " ", 1),
            (_ctx.editable)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "rk-owner-x",
                  title: 'Remove ' + _ctx.teamLabel(t),
                  onClick: ($event: any) => (_ctx.removeTeam(t))
                }, [
                  _createVNode(_component_svg_icon, { icon: "x" })
                ], 8, _hoisted_17))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.editable && _ctx.teamChoices.length)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addTeamName) = $event)),
              class: "rk-owner-add",
              "aria-label": "Add a team",
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addTeam()))
            }, [
              _cache[24] || (_cache[24] = _createElementVNode("option", { value: null }, "+ Add Team", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamChoices, (t) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: t,
                  value: t
                }, _toDisplayString(_ctx.teamLabel(t)), 9, _hoisted_18))
              }), 128))
            ], 544)), [
              [_vModelSelect, _ctx.addTeamName]
            ])
          : _createCommentVNode("", true),
        (!_ctx.editable && !_ctx.form.AdditionalTeams.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "None"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", {
        class: _normalizeClass(["rk-teamrock", [ _ctx.form.TeamRock ? 'on' : '', !_ctx.editable ? 'disabled' : '' ]])
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.TeamRock) = $event)),
          disabled: !_ctx.editable
        }, null, 8, _hoisted_20), [
          [_vModelCheckbox, _ctx.form.TeamRock]
        ]),
        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "rk-teamrock-text" }, [
          _createElementVNode("span", { class: "rk-teamrock-title" }, "Team Rock"),
          _createElementVNode("span", { class: "rk-hint" }, "The whole team works on it, not just the owner. These are visible to the whole company.")
        ], -1))
      ], 2),
      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "rk-label" }, "Done", -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.DoneStatement) = $event)),
        disabled: !_ctx.editable,
        rows: "2",
        maxlength: "1000",
        class: "rk-done",
        placeholder: "A short statement describing the end state of this rock, e.g. \"New quoting process live, used for every quote, with average turnaround under 2 days.\""
      }, null, 8, _hoisted_21), [
        [_vModelText, _ctx.form.DoneStatement]
      ]),
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "rk-label" }, "Status", -1)),
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (s) => {
          return (_openBlock(), _createElementBlock("button", {
            key: s.value,
            type: "button",
            class: _normalizeClass(_ctx.form.Status == s.value ? 'on' : ''),
            disabled: !_ctx.editable && !_ctx.updatable,
            onClick: ($event: any) => (_ctx.setStatus(s.value))
          }, _toDisplayString(s.label), 11, _hoisted_23))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_24, [
        _cache[26] || (_cache[26] = _createTextVNode("Milestones ", -1)),
        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.doneCount) + " of " + _toDisplayString(_ctx.form.Milestones.length) + " done · due by " + _toDisplayString(_ctx.shortDate(_ctx.bounds.end)), 1)
      ]),
      _createVNode(_component_draggable, {
        list: _ctx.form.Milestones,
        handle: ".crm-checklist-handle",
        disabled: !_ctx.editable,
        animation: 150,
        "ghost-class": "kanban-ghost"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Milestones, (m, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: _ctx.milestoneKey(m)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["rk-ms", [ m.Done ? 'done' : '', _ctx.editable ? 'rk-ms-drag' : '' ]])
              }, [
                (_ctx.editable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "⋮⋮"))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => ((m.Done) = $event),
                  disabled: !_ctx.canCheck(m),
                  "aria-label": m.Done ? 'Mark not done' : 'Mark done',
                  onChange: ($event: any) => (_ctx.checkChange(m))
                }, null, 40, _hoisted_27), [
                  [_vModelCheckbox, m.Done]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((m.Text) = $event),
                  disabled: !_ctx.editable,
                  placeholder: "Milestone",
                  class: "rk-ms-text"
                }, null, 8, _hoisted_28), [
                  [_vModelText, m.Text]
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((m.OwnerEmployeeID) = $event),
                  disabled: !_ctx.editable,
                  class: "rk-ms-own",
                  "aria-label": "Milestone owner"
                }, [
                  _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.form.OwnerEmployeeID ? 'Rock owner' : 'No owner'), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: e.ID,
                      value: e.ID
                    }, _toDisplayString(e.Name), 9, _hoisted_31))
                  }), 128))
                ], 8, _hoisted_29), [
                  [_vModelSelect, m.OwnerEmployeeID]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": ($event: any) => ((m.DueDate) = $event),
                  disabled: !_ctx.editable,
                  min: _ctx.bounds.start,
                  max: _ctx.bounds.end,
                  class: "rk-ms-date",
                  "aria-label": "Due date"
                }, null, 8, _hoisted_32), [
                  [_vModelText, m.DueDate]
                ]),
                _createElementVNode("span", _hoisted_33, _toDisplayString(m.DueDate ? 'wk ' + _ctx.weekOfQuarter(_ctx.quarter, m.DueDate) : ''), 1),
                (_ctx.editable)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["rk-ms-ln", m.Link ? 'on' : '']),
                      title: m.Link ? 'Edit link' : 'Add link',
                      onClick: ($event: any) => (_ctx.toggleLink(m))
                    }, [
                      _createVNode(_component_svg_icon, { icon: "link" })
                    ], 10, _hoisted_34))
                  : (m.Link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "rk-ms-ln on",
                        href: m.Link,
                        target: "_blank",
                        rel: "noopener",
                        title: _ctx.milestoneFileName(m.Link) || 'Open link'
                      }, [
                        _createVNode(_component_svg_icon, { icon: "link" })
                      ], 8, _hoisted_35))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36)),
                (_ctx.editable)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 4,
                      class: "rk-ms-x",
                      title: "Remove milestone",
                      onClick: ($event: any) => (_ctx.form.Milestones.splice(i, 1))
                    }, [
                      _createVNode(_component_svg_icon, { icon: "x" })
                    ], 8, _hoisted_37))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.editable && _ctx.linkOpen.includes(m))
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    (_ctx.milestoneFileName(m.Link))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("a", {
                            class: "rk-ms-file",
                            href: m.Link,
                            target: "_blank",
                            rel: "noopener",
                            title: _ctx.milestoneFileName(m.Link)
                          }, [
                            _createVNode(_component_svg_icon, { icon: "link" }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.milestoneFileName(m.Link)), 1)
                          ], 8, _hoisted_39),
                          _createElementVNode("a", {
                            class: "rk-link",
                            onClick: ($event: any) => (m.Link = '')
                          }, "Remove", 8, _hoisted_40)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((m.Link) = $event),
                            disabled: _ctx.uploading.includes(m),
                            placeholder: "Paste a link (optional)",
                            "aria-label": "Milestone link"
                          }, null, 8, _hoisted_41), [
                            [_vModelText, m.Link]
                          ]),
                          (m.Link)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "rk-link",
                                href: _ctx.linkHref(m.Link),
                                target: "_blank",
                                rel: "noopener"
                              }, "Open", 8, _hoisted_42))
                            : _createCommentVNode("", true)
                        ], 64)),
                    (_ctx.uploading.includes(m))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, "Uploading…"))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          class: "rk-link",
                          onClick: ($event: any) => (_ctx.pickFile(m))
                        }, _toDisplayString(_ctx.milestoneFileName(m.Link) ? 'Replace File' : 'Upload File'), 9, _hoisted_44))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["list", "disabled"]),
      _createElementVNode("input", {
        ref: "fileInput",
        type: "file",
        style: {"display":"none"},
        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
      }, null, 544),
      (!_ctx.form.Milestones.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_45, "Break the rock into 3 to 7 milestones, one every 2 to 4 weeks. Each can have its own owner."))
        : _createCommentVNode("", true),
      (_ctx.editable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "rk-add-ms",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addMilestone()))
          }, "+ Add Milestone"))
        : _createCommentVNode("", true),
      (_ctx.editable)
        ? (_openBlock(), _createBlock(_component_forge_rock_milestones, {
            key: 2,
            rockID: _ctx.existing ? _ctx.existing.ID : 0,
            form: _ctx.form,
            quarter: _ctx.quarter,
            employees: _ctx.employees,
            onAdd: _ctx.addDrafted
          }, null, 8, ["rockID", "form", "quarter", "employees", "onAdd"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_46, [
        (_ctx.existing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
              (_ctx.teams.length)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "rk-link",
                    onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.clone()), ["prevent"]))
                  }, "Clone"))
                : _createCommentVNode("", true),
              (_ctx.updatable && _ctx.canCarry)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "rk-link",
                    onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.carry()), ["prevent"]))
                  }, "Carry to " + _toDisplayString(_ctx.quarterLabel(_ctx.nextQuarter(_ctx.quarter))), 1))
                : _createCommentVNode("", true),
              (_ctx.onBoard)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "rk-danger",
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.$emit('remove-from-board')), ["prevent"]))
                  }, "Remove from Board"))
                : _createCommentVNode("", true),
              (_ctx.editable)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    class: "rk-danger",
                    onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.showConfirmDelete = true), ["prevent"]))
                  }, "Delete"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", {
            class: "btn-light",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('close')))
          }, _toDisplayString(_ctx.editable ? 'Cancel' : 'Close'), 1),
          (_ctx.editable)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["btn", _ctx.saving ? 'disable-button' : '']),
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.save()))
              }, _toDisplayString(_ctx.existing ? 'Save' : 'Add Rock'), 3))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.remove())),
          onCancel: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showConfirmDelete = false)),
          msg: "Delete this rock and its milestones?"
        }))
      : _createCommentVNode("", true)
  ]))
}